<template>
  <div class="gift-card-universal-instance-list">
    <v-row justify="end">
      <v-col cols="3" class="mb-4">
        <v-btn @click="openCreateDialog" block depressed color="primary">Create Gift Card</v-btn>
      </v-col>
    </v-row>
    <v-data-table
      v-if="instances"
      :options="{ itemsPerPage: -1 }"
      sort-by="createdAt"
      :headers="headers"
      :items="instances">
      <template v-slot:item.name="{ item }">
        {{ item.name }}
      </template>
      <template v-slot:item.code="{ item }">
        {{ item.code }}
      </template>
      <template v-slot:item.expirationMonths="{ item }">
        {{ formatDate(item.expiresAt) }}
      </template>
      <template v-slot:item.id="{ item }">
        <v-row>
          <v-col class="text-right">
            <v-btn v-if="item" x-small dark depressed @click="viewInstance($event, item)">
              View
            </v-btn>
          </v-col>
          <v-col>
            <v-btn v-if="item" x-small color="primary" depressed @click="editInstance($event, item)">
              Edit
            </v-btn>
          </v-col>
        </v-row>
      </template>
    </v-data-table>

    <v-dialog
      transition="dialog-bottom-transition"
      dismissable
      width="700"
      v-if="createDialog"
      :value="createDialog"
    >
      <v-card tile>
        <v-card-title>
          <h2>Create Gift Card</h2>
        </v-card-title>
        <v-divider class="mb-4" />
        <v-card-text>
          <v-form>
            <v-row>
              <v-col>
                <v-text-field
                  label="Name"
                  outlined
                  v-model="createItem.name"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-textarea
                  v-model="approvedRedeemers"
                  label="Approved Redeemers (optional)"
                  hint="Enter the email addresses of approved redeemers, separated by commas. If left blank, anyone can redeem the gift card."
                  outlined
                  clearable
                ></v-textarea>
              </v-col>
            </v-row>

            <v-btn
              depressed
              color="primary"
              block
              @click="createInstance"
              :loading="instanceCreateLoading"
              :disabled="instanceCreateLoading">
              Create
            </v-btn>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      transition="dialog-bottom-transition"
      dismissable
      width="500"
      v-if="editDialog"
      :value="editDialog"
      @input="editClose"
    >
      <v-card tile>
        <v-card-title>
          <h2>Edit Gift Card</h2>
        </v-card-title>
        <v-divider class="mb-4" />
        <v-card-text>
          <v-form>
            <v-row>
              <v-col>
                <v-text-field
                  outlined
                  v-model="editItem.name"
                  label="Name"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-textarea
                  v-model="editItem.approvedRedeemers"
                  label="Approved Redeemers (optional)"
                  hint="Enter the email addresses of approved redeemers, separated by commas. If left blank, anyone can redeem the gift card."
                  outlined
                  clearable
                ></v-textarea>
              </v-col>
            </v-row>

            <v-btn
              depressed
              color="primary"
              block
              @click="updateInstance"
              :loading="instanceUpdateLoading"
              :disabled="instanceUpdateLoading">
              Update
            </v-btn>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      transition="dialog-bottom-transition"
      dismissable
      fullscreen
      v-if="viewDialog"
      :value="viewDialog"
      @input="viewDialog = false">
      <v-card tile>
        <v-card-title>
          <v-row>
            <v-col cols="8"><h2>View Gift Card - {{ viewInstanceObj.code }}</h2></v-col>
            <v-spacer />
            <v-col class="text-right">
              <v-btn icon @click="closeViewInstance">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          
        </v-card-title>
        <v-divider class="mb-4" />
        <v-card-text>
          <v-row>
            <v-col>
              <v-data-table
                v-if="viewInstanceRedemptions"
                :options="{ itemsPerPage: -1 }"
                sort-by="purchaseDate"
                :headers="viewInstanceHeaders"
                :items="viewInstanceRedemptions">
                <template v-slot:item.redeemedByName="{ item }">
                  <a :href="`https://rayoga.marianatek.com/admin/user/profile/${item.redeemedBy}/payment-methods`" target="_blank">{{  item.redeemedByName }}</a>
                </template>
                <template v-slot:item.redeemedByEmail="{ item }">
                  {{ item.redeemedByEmail }}
                </template>
                <template v-slot:item.id="{ item }">
                  {{ formatDate(item.createdAt) }}
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { DateTime } from 'luxon'

export default {
  name: 'GiftCardUniversalInstanceList',

  props: [
    'configId',
  ],

  data() {
    return {
      editDialog: false,
      editItem: null,
      createDialog: false,
      createItem: {},
      viewDialog: false,
      viewInstanceObj: null,
      approvedRedeemers: null,
      headers: [
        {
          text: 'Name',
          value: 'name',
        },
        {
          text: 'Code',
          value: 'code',
        },
        {
          text: 'Exires At',
          value: 'expiresAt',
        },
        {
          text: '',
          value: 'id'
        }
      ],
      viewInstanceHeaders: [
        {
          text: 'Name',
          value: 'redeemedByName',
        },
        {
          text: 'Email',
          value: 'redeemedByEmail',
        },
        {
          text: 'Redeemed At',
          value: 'createdAt',
        },
      ]
    }
  },

  computed: {
    ...mapGetters({
      instances: 'gift-card-universal-instance/list',
      users: 'mariana-user/list',
      viewInstanceRedemptions: 'gift-card-universal-redemption-ledger/list',
    }),

    usersLoading() {
      return this.$store.state['mariana-user'].isFindPending
    },

    instanceCreateLoading() {
      return this.$store.state['gift-card-universal-instance'].isCreatePending
    },
    instanceUpdateLoading() {
      return this.$store.state['gift-card-universal-instance'].isPatchPending
    },
  },

  watch: {
    async gifteeSearch(val) {
      if (this.usersLoading) return
      await this.$store.dispatch('mariana-user/find', {
        query: {
          email_query: val,
        }
      })
    }
  },

  methods: {
    async getInstances() {
      this.$store.dispatch('gift-card-universal-instance/find', {
        query: {
          giftCardUniversalConfigId: this.configId,
          $limit: 1000,
        }
      })
    },

    async createInstance() {
      await this.$store.dispatch('gift-card-universal-instance/create', {
        approvedRedeemers: (this.approvedRedeemers) ? this.approvedRedeemers.split(',').map(e => e.trim()) : [],
        name: this.createItem.name,
        giftCardUniversalConfigId: this.configId,
      }).then(res => {
        if (res) {
          this.closeCreateDialog()
        }
      })
    },

    async updateInstance() {
      await this.$store.dispatch('gift-card-universal-instance/patch', [this.editItem.id, {
        approvedRedeemers: (this.editItem.approvedRedeemers && this.editItem.approvedRedeemers.length > 0) ? this.editItem.approvedRedeemers.split(',').map(e => e.trim()) : [],
        name: this.editItem.name,
      }]).then(res => {
        if (res) {
          this.editClose()
        }
      })
    },

    async getInstanceRedemptions(id) {
      await this.$store.dispatch('gift-card-universal-redemption-ledger/find', {
        query: {
          giftCardUniversalInstanceId: id,
          $limit: 1000
        }
      })
    },

    openCreateDialog() {
      this.createDialog = true;
    },

    closeCreateDialog() {
      this.createDialog = false
    },

    editInstance(e, item) {
      this.editDialog = true
      this.editItem = item
    },

    editClose() {
      this.editDialog = false
      this.editItem = null
    },

    async viewInstance(e, item) {
      this.$store.commit('gift-card-universal-redemption-ledger/clearAll', this.$store.state['gift-card-universal-redemption-ledger'])
      await this.getInstanceRedemptions(item.id)
      this.viewInstanceObj = item,
      this.viewDialog = true
    },

    closeViewInstance() {
      this.viewDialog = false
      this.viewInstanceObj = null
    },

    formatDate(date) {
      return DateTime.fromISO(date).toLocaleString(DateTime.DATETIME_MED)
    }
  },

  async beforeMount() {
    await this.getInstances()
  },

  beforeDestroy() {
    this.$store.commit('gift-card-universal-instance/clearAll')
  },
}
</script>

<style lang="scss">

</style>